import { Component, OnInit } from '@angular/core';
import { ClinicQuery } from '../../../../shared/state/clinic/clinic.query';
import { UserQuery } from '../../../../shared/state/user/user.query';
import { Observable } from 'rxjs';
import { UserState } from '../../../../shared/state/user/user.store';
import { UserService } from '../../../../shared/state/user/user.service';
import { UserEditModel } from '../../../../shared/models/userEdit.model';
import { Router } from '@angular/router';
import { SettingsQuery } from '../../../../shared/state/settings/settings.query';
import { ClinicDetailQuery } from '../../../../shared/state/clinic-detail/clinic-detail.query';
import {
    AlertController,
    ModalController,
    NavController,
    Platform,
} from '@ionic/angular';
import { HeaderPictureQuery } from '../../../../shared/state/header-picture/header-picture.query';
import { HeaderBackgroundQuery } from '../../../../shared/state/header-background/header-background.query';
import { HeaderIconQuery } from '../../../../shared/state/header-icon/header-icon.query';
import { LibraryService } from '../../../../core/services/library/library.service';
import { CompanyQuery } from '../../../../shared/state/company/company.query';
import { UserAccountEditComponent } from '../../../user-account-edit/pages/user-account-edit/user-account-edit.component';
import { RouterService } from '../../../../core/services/router/router.service';
import { ToastService } from '../../../../core/services/toast/toast.service';
import { filter, take } from 'rxjs/operators';
import { UserReferrerData } from '../../../../shared/models/userReferrerData';
import { Clipboard } from '@capacitor/clipboard';
import { Share } from '@capacitor/share';
import { Capacitor } from '@capacitor/core';

@Component({
    selector: 'app-user-account',
    templateUrl: './user-account.component.html',
    styleUrls: ['./user-account.component.scss'],
})
export class UserAccountComponent implements OnInit {
    user$: Observable<UserState>;
    enableRGPD = false;
    browser$: Observable<boolean>;
    isLoadingContent;
    headerPicture$;
    headerBackground$;
    headerIcon$;

    /** Flowwwer template */
    clinicName$: Observable<string>;

    clinicDetailRgpdDisable$: Observable<boolean>;
    isUserAccountATab: boolean;
    isFriendProgramATab: boolean;
    isFriendProgramInUserAccount: boolean;
    isClientPointsEnabled: boolean;

    isMac: boolean;
    isChrome: boolean;
    isFirefox: boolean;
    public isNative: boolean = Capacitor.isNativePlatform();
    public canShare: boolean;

    referrerData$: Observable<UserReferrerData>;
    showClinicDetails: boolean;
    showBackButtonHeader$: Observable<boolean>;
    public isBrowser = !Capacitor.isNativePlatform();

    constructor(
        private clinicQuery: ClinicQuery,
        private userQuery: UserQuery,
        private userService: UserService,
        private router: Router,
        private settingsQuery: SettingsQuery,
        private clinicDetailQuery: ClinicDetailQuery,
        private navCtrl: NavController,
        private headerPictureQuery: HeaderPictureQuery,
        private headerBackgroundQuery: HeaderBackgroundQuery,
        private headerIconQuery: HeaderIconQuery,
        private alertCtrl: AlertController,
        private platform: Platform,
        private libraryService: LibraryService,
        private companyQuery: CompanyQuery,
        private modalController: ModalController,
        private routerService: RouterService,
        private toastService: ToastService
    ) {}

    getUserAvatarImageUrl(userName: string): string {
        const backgroundColor = document.documentElement.style
            .getPropertyValue('--ion-color-primary')
            .substring(1);
        const textColor = document.documentElement.style
            .getPropertyValue('--ion-color-primary-contrast')
            .substring(1);

        return `https://eu.ui-avatars.com/api/?name=${encodeURIComponent(
            userName
        )}&background=${backgroundColor}&color=${textColor}&rounded=false&size=120`;
    }

    async changeEnableRGPD() {
        if (this.enableRGPD !== this.userQuery.enableRGPD) {
            const editUser: UserEditModel = {
                tokenId: this.userQuery.tokenId,
                phone: this.userQuery.phone,
                email: this.userQuery.email,
                enableRgpd: this.enableRGPD,
                points: this.userQuery.points,
            };
            try {
                await this.userService.editEnableRGPDUser(editUser);
            } catch (e) {
                this.enableRGPD = this.userQuery.enableRGPD;
            }
        }
    }

    async ngOnInit(): Promise<void> {
        this.canShare = (await Share.canShare()).value;
        this.headerPicture$ = this.headerPictureQuery.select('account');
        this.headerBackground$ = this.headerBackgroundQuery.select('account');
        this.headerIcon$ = this.headerIconQuery.select('account');
        this.user$ = this.userQuery.select();
        this.userQuery.select('enableRGPD').subscribe((enableRGPDData) => {
            this.enableRGPD = enableRGPDData;
        });
        this.browser$ = this.settingsQuery.select('browser');
        this.clinicDetailRgpdDisable$ = this.clinicDetailQuery.select(
            'RGPDDisable'
        );

        this.settingsQuery.selectIsUserAccountATab().subscribe((value) => {
            this.isUserAccountATab = value;
        });
        this.settingsQuery.selectIsFriendProgramATab().subscribe((value) => {
            this.isFriendProgramATab = value;
        });
        this.settingsQuery.selectIsClientPointsEnabled().subscribe((value) => {
            this.isClientPointsEnabled = value;
        });
        this.settingsQuery
            .selectIsFriendProgramInUserAccount()
            .subscribe((value) => {
                this.isFriendProgramInUserAccount = value;

                if (
                    value &&
                    (!this.userQuery.advisorCode ||
                        this.userQuery.advisorCode === '')
                ) {
                    this.userQuery
                        .select()
                        .pipe(
                            filter(({ tokenId }) => tokenId !== ''),
                            take(1)
                        )
                        .subscribe(async () => {
                            await this.getReferrerData();
                        });
                }
            });

        this.isMac = navigator.platform.indexOf('Mac') > -1;
        this.isChrome = /Google Inc/.test(navigator.vendor);
        this.isFirefox = /Firefox/.test(navigator.userAgent);

        this.referrerData$ = this.userQuery.select('referrer');

        /** Flowwwer template */
        this.clinicName$ = this.clinicDetailQuery.select('commercialName');
        this.showBackButtonHeader$ = this.settingsQuery.selectShowBackButtonHeader();
    }

    onClickEdit() {
        this.router.navigate([
            '/' +
                this.settingsQuery.systemKeyURL +
                '/' +
                this.clinicDetailQuery.id +
                '/user-account-edit',
        ]);
    }

    async refreshUser(event) {
        this.isLoadingContent = true;
        try {
            await this.userService.checkUserAndLoad(true);
            if (this.isFriendProgramInUserAccount) {
                await this.getReferrerData();
            }
        } catch (error) {
            this.routerService.goToMainTabWithoutLogin();
            this.isLoadingContent = false;
            //Si este componente está actuando como modal, me cierro
            if (!this.isUserAccountATab) {
                this.dismissModal();
            }
        }
        this.isLoadingContent = false;

        event.target.complete();
    }

    logout() {
        this.userService.deleteCurrentTokenLocalStorage();
        this.userService.resetStore();
        this.routerService.goToMainTabWithoutLogin();

        if (!this.isUserAccountATab) {
            this.dismissModal();
        }
    }

    async showConfirmLogout() {
        const alert = await this.alertCtrl.create({
            mode: this.platform.is('android') ? 'md' : 'ios',
            message: this.libraryService.getLabel('app_con_logout'),
            buttons: [
                {
                    text: this.libraryService.getLabel(
                        'app_ask_sched_step_3_button'
                    ),
                    role: 'confirm',
                    handler: () => {
                        this.logout();
                    },
                },
                {
                    text: this.libraryService.getLabel('app_action_cancel'),
                    role: 'cancel',
                },
            ],
        });
        await alert.present();
    }

    async presentModalUserAccountEdit() {
        const modal = await this.modalController.create({
            component: UserAccountEditComponent,
            cssClass: this.settingsQuery.browser
                ? 'modal-flowwwer modal-browser'
                : 'modal-flowwwer',
            componentProps: {
                isModal: true,
            },
        });
        await modal.present();

        const closeModal = await modal.onDidDismiss();

        if (closeModal.role === 'deleteClient') {
            setTimeout(() => {
                this.dismissModal()
            }, 100);
        }
    }

    dismissModal() {
        this.modalController.dismiss({
            dismissed: true,
        });
    }

    async share(url: string): Promise<void> {
        if(this.canShare){
            Share.share({
                title: this.libraryService.getLabel('app_share_title'),
                text: this.userQuery.advisorShareText,
                url,
                dialogTitle: this.libraryService.getLabel('app_share_dialog_title'),
            });
        }else{
            this.toastService.presentErrorToast(
                this.libraryService.getLabel('lbl_share_not_enabled')
            );
        }
    }

    async copy(code: string): Promise<void> {
        try {
            await Clipboard.write({
                string: code,
            });
            await this.toastService.presentInfoToast(
                this.libraryService.getLabel('app_copy_success')
            );
        } catch (e) {
            await this.toastService.presentErrorToast(
                this.libraryService.getLabel('app_copy_error')
            );
        }
    }

    /** Flowwwer template */
    goHome(event) {
        event?.stopPropagation();
        /** Solo puedo volver atrás si no estoy en personalzas o si soy personalizada y tengo más de 1 centro */
        if (
            !this.settingsQuery.isPersonalized() ||
            this.clinicQuery.getValue().clinicsFound.length > 1
        ) {
            this.navCtrl.navigateBack(
                '/' +
                    (this.settingsQuery.isPersonalized()
                        ? this.settingsQuery.currentSystemKey
                        : '')
            );
        }
    }

    get accumulatedPointsLabel(): string {
        return this.libraryService
            .getLabel('lbl_accumulated_points')
            .replace('###POINTS###', this.userQuery.points?.toString());
    }

    private async getReferrerData(): Promise<void> {
        await this.userService.getReferrerData();
    }
}
